{
  "greeting": {
    "salam": "Assalamu alaikum",
    "salamWithName": "Assalamu alaikum, {{name}}"
  },
  "dock": {
    "saved": "An ajiye",
    "savedVerses": "Ayoyin da aka ajiye",
    "tasks": "Ayyuka",
    "notes": "Bayanai"
  },
  "actions": {
    "save": "Ajiye",
    "cancel": "Soke",
    "close": "Rufe",
    "delete": "Share",
    "rename": "Sake suna",
    "dismiss": "Cire",
    "loading": "Ana lodi…",
    "reload": "Sake lodi",
    "retry": "Sake gwadawa",
    "expand": "Faɗaɗa",
    "collapse": "Rage"
  },
  "nav": {
    "appNavigation_aria": "Kewayawar manhaja"
  },
  "tabs": {
    "home": "Gida",
    "tasks": "Ayyuka",
    "notes": "Bayanai",
    "more": "Ƙari"
  },
  "more": {
    "daily": "Yau da kullum",
    "account": "Asusu",
    "savedVerses": "Ayoyin da aka ajiye",
    "qibla": "Alƙibla",
    "prayerTimes": "Lokutan Sallah da Tunatarwa",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Ana sarrafa shi ta asusunka na Rhemn",
    "upgrade": "Haɓaka",
    "privacyPolicy": "Manufar Sirri",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Koma baya",
    "deleteAccount": "Share asusu"
  },
  "reflection": {
    "dismiss_aria": "Cire tunani"
  },
  "app": {
    "loading_aria": "Ana lodin Rhemn",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Sarrafa biyan kuɗin Rhemn Pro ɗinka a yanar gizo. Pro yana buɗewa kai tsaye a nan idan ka shiga da asusunka mai biyan kuɗi."
  },
  "header": {
    "qiblaDirection_aria": "Alƙibla",
    "prayerTimes_aria": "Lokutan sallah",
    "prayerTimesTitle": "Lokutan Sallah",
    "method": "Hanya",
    "methodHelp": "Hanya tana shafar lokutan da aka ƙididdige"
  },
  "search": {
    "search_aria": "Bincike",
    "searchLabel": "Bincike",
    "searchWeb_placeholder": "Bincika a yanar gizo"
  },
  "focus": {
    "input_placeholder": "Me ya fi muhimmanci a yau?",
    "example_worship": "Yin sallah da natsuwa, ba da gaggawa ba",
    "example_kindness": "Kiran mahaifiyata don in saurare ta kawai",
    "example_reflect": "Yi tunani a kan niyyarka da ayar yau",
    "saveIntention_aria": "Ajiye niyya",
    "celebration": "🤲 Mashalla"
  },
  "profile": {
    "profileFallback": "Bayani",
    "profileAndAccount_aria": "Bayani da asusu",
    "profileDialog_aria": "Bayani",
    "editName_aria": "Gyara sunanka",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Sarrafa biyan kuɗi",
    "manageSubscription_aria": "Sarrafa biyan kuɗin Rehmn Pro ɗinka",
    "anonymousAnalytics": "Bincike marar suna",
    "anonymousAnalyticsNote": "Tarawa kaɗai — ba a haɗa shi da kai ba",
    "shareAnalytics_aria": "Raba bincike marar suna na amfani",
    "signOut": "Fita",
    "signingOut": "Ana fita…",
    "signOut_aria": "Fita daga Rehmn",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "Ana lodin bayan fage...",
    "fallbackNotice": "Ana amfani da hoton madadin (Unsplash API babu)",
    "noImage": "Babu hoton bayan fage",
    "error": "Kuskure: {{message}}",
    "photoByOnUnsplash": "Hoton <photographer>{{name}}</photographer> a kan <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Wani abu ya yi kuskure",
    "fallbackMessage": "Kuskuren da ba a zata ba ya faru."
  },
  "theme": {
    "switchToLight_title": "Canza zuwa yanayin haske",
    "switchToDark_title": "Canza zuwa yanayin duhu"
  },
  "upgradeCta": {
    "upgradeToPro": "Haɓaka zuwa Pro",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "pricePerMonth": "{{price}} / wata",
    "pricePerYear": "{{price}} / shekara",
    "purchasePending": "Ana jiran amincewa. Pro zai buɗe kai tsaye da zarar an amince da sayan.",
    "storeUnavailable": "Ba a iya isa ga App Store a yanzu ba. Sake gwadawa nan da ɗan lokaci.",
    "purchaseFailed": "Ba a kammala sayan ba. Sake gwadawa nan da ɗan lokaci."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · Rangwamen 25% a shekarar farko",
    "title": "Don sa'o'in da ke tsakanin sallolinka.",
    "body": "Bayanan murya da ake rubutawa, a taƙaita, su zama ayyuka. Tsarin yini da aka gina kewaye da lokutan sallarka. Bayanai tare da AI.",
    "price": "$29.99",
    "period": "na shekarar farko",
    "priceIos": "Rangwamen 25% a shekarar farko",
    "terms": "Sannan $39.99 a shekara. An saka maka lambar {{code}}.",
    "termsIos": "Yana sabuntawa da farashin shekara na yau da kullum. Yi amfani da lambar {{code}} a App Store.",
    "free": "Lokutan sallah, Alƙibla, ayar yau da ayyuka za su ci gaba da zama kyauta.",
    "cta": "Haɓaka zuwa Pro",
    "dismiss": "Ba yanzu ba"
  },
  "planChooser": {
    "monthly": "Kowane wata",
    "yearly": "Kowace shekara",
    "yearlyValue": "Watanni huɗu kyauta daga gare mu.",
    "freeNote": "Lokutan sallah, Alƙibla, ayar yini da ayyuka kyauta ne. Rhemn Pro yana ƙarawa:",
    "includes_planner": "Tsarin yini da aka gina kewaye da sallolin nan biyar, da “Tsara min yini”",
    "includes_insights": "Quran Insights — yi tambaya kan kowace aya ka karanta mahallinta",
    "includes_reflections": "Tunani kan ayar yini, bisa nufin da ka sanya",
    "includes_notes": "Rubuce-rubuce da na murya, tare da taƙaitawa ta AI",
    "includes_extras": "Ayoyin da aka ajiye, katunan aya, jerin kwanaki, da hasashen kwana 5",
    "renewsMonthly": "Yana sabuntawa kowane wata har sai an soke",
    "renewsYearly": "Yana sabuntawa kowane wata 12 har sai an soke",
    "continue": "Ci gaba",
    "renewalTerms": "Za a cire kuɗi daga Apple ID ɗinka lokacin tabbatarwa. Biyan kuɗi yana sabuntawa ta atomatik sai an kashe sabuntawa aƙalla sa'o'i 24 kafin ƙarshen lokacin. Za ka iya sarrafawa ko sokewa a kowane lokaci a saitunan Apple ID.",
    "retry": "Sake gwadawa"
  },
  "streak": {
    "badge_aria": "Dagewar yau da kullum — kwanaki {{count}}",
    "title": "Dagewar yau da kullum",
    "daysWithCount": "Dagewar kwanaki {{count}}",
    "start": "Fara yau — ka ɗan yi lokaci da ayar ko ka yi alamar sallah.",
    "prayedToday": "Na yi sallah yau",
    "readVerse": "Na karanta ayar yau",
    "autoHint": "Ayar takan yi alama da kanta idan ka ɗan yi lokaci da ita.",
    "milestoneTitle": "Kwanaki {{count}} na niyya",
    "milestoneBody": "Alhamdulillah. Raba wannan nasara — wanda kake ƙauna ma zai iya farawa.",
    "share": "Raba",
    "dismiss": "Ba yanzu ba",
    "cardLabel": "kwanaki na niyya",
    "shareCaption": "Kwanaki {{count}} na farawa da niyya — rhemn.com",
    "imageSaved": "An ajiye hoton.",
    "couldNotCreateImage": "Ba a iya ƙirƙirar hoton ba. Da fatan a sake gwadawa."
  },
  "qibla": {
    "compassIcon_aria": "Alamar kamfas",
    "title": "Alƙibla",
    "locationUnavailable": "Wuri babu",
    "locating": "Ana neman wuri…",
    "compass_aria": "Kamfas na Alƙibla",
    "directionN": "A",
    "directionE": "G",
    "directionS": "K",
    "directionW": "Y",
    "facingQibla": "Kana fuskantar Alƙibla",
    "enableLiveCompass": "Kunna Kamfas na Kai Tsaye",
    "enableLiveCompassNote": "Yana amfani da na'urar gano motsi don kibiya ta bi sa'ad da ka juya — ba wuri ba",
    "directionToMecca": "Hanya zuwa Makka",
    "enableLocation": "Kunna izinin wuri don ƙididdige hanya",
    "hintLive": "Kibiya tana bin yadda na'urarka ke fuskanta a ainihin lokaci",
    "hintStatic": "Daga Arewa — yi amfani da kamfas don ainihin hanya",
    "live": "Kai tsaye",
    "footerVerse": "\"Sai ka fuskanci Masallaci Mai Tsarki\" – Alƙur'ani 2:144"
  },
  "legal": {
    "links_aria": "Doka",
    "termsOfUse": "Sharuɗɗan amfani",
    "privacyPolicy": "Manufar Sirri"
  },
  "auth": {
    "signInForPro": "Fara shiga — Pro naka yana tafiya tare da kai ko'ina."
  },
  "integrations": {
    "row": {
      "label": "Kalanda da ayyuka",
      "caption": "An haɗa",
      "subNone": "Ba a haɗa ba",
      "subFree": "Google Calendar, Google Tasks da ƙari",
      "subAttention": "{{provider}} yana buƙatar kulawa",
      "subPaused": "An dakatar da daidaitawa"
    },
    "list": {
      "title": "Kalanda da ayyuka",
      "subtitle": "Kawo tarurruka da ayyukanka cikin ranarka.",
      "footnote": "Rhemn yana karanta abin da yake bukata kawai, kuma ba ya taɓa ajiye abubuwan da ka tsara.",
      "privacy": "Manufar Sirri",
      "connect": "Haɗa",
      "connect_aria": "Haɗa {{what}}",
      "checking": "Ana bincike…",
      "loadError": "An kasa loda haɗin ka.",
      "tryAgain": "Sake gwadawa",
      "offline": "Kana ba a kan layi ba. Haɗa idan ka dawo kan layi.",
      "unavailable": "Kalanda da ayyuka ba su samuwa a yanzu.",
      "disconnected": "An cire haɗin {{provider}}.",
      "google": {
        "name": "Google",
        "sub": "Kalanda da ayyuka",
        "what": "Google Calendar da Google Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Ayyuka da shirye-shirye",
        "what": "Todoist"
      },
      "apple": {
        "name": "Kalanda da Tunatarwa",
        "subNative": "A wannan {{device}}",
        "subSafari": "A cikin manhajar Rhemn don iPhone da Mac"
      },
      "synced": "An daidaita {{when}}",
      "connectedSub": "An haɗa",
      "syncing": "Ana daidaitawa…",
      "reconnectSub": "Sake haɗawa don ci gaba da daidaitawa",
      "errorSub": "Daidaitawa ta ƙarshe ba ta ƙare ba",
      "pausedSub": "An dakatar · Rhemn Pro ya ƙare"
    },
    "explainer": {
      "google": {
        "title": "Haɗa Google Calendar da Google Tasks",
        "p1Lead": "Kalandarka, karantawa kawai",
        "p1Body": "Rhemn yana nuna abubuwan da ka tsara a ranarka kuma yana gane lokacin da kake shagaltuwa. Ba ya ajiye su.",
        "p2Lead": "Google Tasks, ta kowace hanya",
        "p2Body": "Jerin da ka zaɓa suna ci gaba da daidaitawa, don ka iya cirewa daga ko'ina.",
        "p3Lead": "Za ka iya sokewa",
        "p3Body": "Cire haɗin a kowane lokaci, a nan ko a asusunka na Google.",
        "footnote": "Google zai nuna maka daidai abin da Rhemn ke nema."
      },
      "todoist": {
        "title": "Haɗa Todoist",
        "p1Lead": "Ayyukanka, ta kowace hanya",
        "p1Body": "Ayyukan da ka zaɓa suna ci gaba da daidaitawa, don ka iya cirewa daga ko'ina.",
        "p2Lead": "Yadda yake daidaitawa",
        "p2Body": "Fifikon Todoist yana zama Mafi Muhimmanci, Babba, Matsakaici, da Ƙarami. Ƙananan ayyuka masu zurfi fiye da matakin ɗaya suna bayyana kamar matakai a ƙarƙashin babban aikinsu.",
        "p3Lead": "Za ka iya sokewa",
        "p3Body": "Cire haɗin a kowane lokaci, a nan ko a saitunan Todoist.",
        "cta": "Ci gaba zuwa Todoist",
        "footnote": "Todoist zai tambaye ka ka tabbatar."
      },
      "skip": "Ba yanzu ba",
      "cancel": "Soke",
      "waiting": "Ana jiran {{provider}}…",
      "safariWaiting": "Kammala a sabon shafin, sannan ka dawo nan.",
      "safariReopen": "Sake buɗe shafin",
      "denied": "{{provider}} bai bayar da izini ba, don haka babu abin da aka haɗa.",
      "error": "An kasa haɗawa da {{provider}}. Sake gwadawa bayan ɗan lokaci."
    },
    "detail": {
      "back_aria": "Koma zuwa Kalanda da ayyuka",
      "syncNow": "Daidaita yanzu",
      "intro": "Zaɓi abin da Rhemn zai daidaita. Za ka iya canja wannan a kowane lokaci.",
      "taskLists": "Jerin ayyuka",
      "projects": "Shirye-shirye",
      "reminders": "Tunatarwa",
      "calendars": "Kalanda",
      "rhemnCalendarSub": "Lokutan sallarka, ba a ƙidaya su a matsayin shagaltuwa ba",
      "loading": "Ana lodi…",
      "loadError": "An kasa loda jerin ka.",
      "emptyGoogle": "Babu jerin ayyuka a Google Tasks.",
      "emptyTodoist": "Babu shirye-shirye a Todoist.",
      "addError": "An kasa ƙara {{name}}. Sake gwadawa.",
      "removed": "An cire daga Rhemn. Har yanzu yana cikin {{provider}}.",
      "undo": "Soke aikin",
      "prayerTimes": "Ƙara lokutan sallah a kalandarka",
      "prayerTimesSub": "Yana ƙara sallah biyar a kalanda mai suna Rhemn, na kwanaki 7 masu zuwa, don kada mutane su yi tanadi a kansu.",
      "prayerTimesOn": "A kunne. An ƙara har zuwa {{date}}.",
      "prayerTimesWaiting": "Ana jiran Google…",
      "prayerTimesDenied": "Google bai bada izini ba. Ba a ƙara komai ba.",
      "prayerTimesRemoveAsk": "Cire lokutan sallah na Rhemn daga kalandarka?",
      "prayerTimesKeep": "Ajiye su",
      "prayerTimesRemove": "Cire",
      "meetingPrompts": "Tunatarwar tarurruka",
      "meetingPromptsSub": "Idan taro mai hanyar haɗi zai fara, yana ba da shawarar ɗaukar bayanai.",
      "busyFootnote": "\"Tsara ranata\" yana ganin lokacin da kake shagaltuwa kawai, ba ya taɓa ganin abin da tarurrukanka suke ba.",
      "todoistFootnote": "Fifikon Todoist yana zama Mafi Muhimmanci, Babba, Matsakaici, da Ƙarami. Ƙananan ayyuka masu zurfi fiye da matakin ɗaya suna bayyana kamar matakai a ƙarƙashin babban aikinsu.",
      "reauth": "{{provider}} ya daina barin Rhemn ya daidaita. Wannan yana faruwa idan an cire izini ko kalmar sirrinka ta canja.",
      "reconnect": "Sake haɗawa",
      "paused": "An dakatar da daidaitawa domin Rhemn Pro ya ƙare. Jerin ka za su kasance kamar yadda suke.",
      "calendarDenied": "An kashe izinin kalanda.",
      "remindersDenied": "An kashe izinin tunatarwa.",
      "disconnect": "Cire haɗin {{provider}}",
      "disconnectTitle": "Cire haɗin {{provider}}?",
      "disconnectBody": "Ba a share komai a {{provider}} ba.",
      "disconnectRhemnCal": "Za a cire kalandar lokutan sallah na Rhemn daga Google Calendar.",
      "disconnectError": "An kasa cire haɗin {{provider}}. Sake gwadawa bayan ɗan lokaci.",
      "keepLists": "Ajiye jerina a Rhemn",
      "keepListsSub": "Za su daina daidaitawa su zama jerin Rhemn na yau da kullum.",
      "removeLists": "Cire su daga Rhemn",
      "removeListsSub": "Kwafi kawai da ke Rhemn za a cire.",
      "disconnecting": "Ana cire haɗin…",
      "appleStop": "Daina amfani da Kalanda da Tunatarwa",
      "appleStopTitle": "Daina amfani da Kalanda da Tunatarwa?",
      "appleStopBody": "Rhemn zai daina nuna abubuwan da ka tsara da tunatarwarka. Domin cire izininsa gaba ɗaya, kashe shi a Saituna.",
      "justNow": "yanzu-yanzu",
      "tasksScope": "Rhemn na buƙatar izini don ganin Google Tasks naka. Sake haɗawa sannan ka zaɓi Ayyuka don ba da izini.",
      "calendarsLoadError": "An kasa loda kalandarka.",
      "calendarsEmpty": "Babu kalanda a wannan asusun.",
      "calendarsScope": "Rhemn yana bukatar izini don ganin Google Calendar ɗinka. Sake haɗawa ka zaɓi Calendar don ba da izini.",
      "prayerTimesError": "An kasa ƙara lokutan sallarka. Sake gwadawa nan ba da jimawa ba.",
      "remindersEmpty": "Babu jeri a Tunatarwa.",
      "openSettings": "Buɗe Saituna",
      "appleStopCta": "Daina amfani"
    },
    "locked": {
      "body": "Ga tarurrukanka a cikin lokutan sallarka, kuma ka riƙe Google Tasks yana daidaitawa da Rhemn.",
      "googleName": "Google Calendar da Google Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "na'ura"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, an daidaita da {{provider}}",
      "unlinkConfirm": "Cire “{{name}}” daga Rhemn? Zai ci gaba da kasancewa a {{provider}}.",
      "remove": "Cire",
      "offline": "Ba a kan layi ba · Canje-canje za su daidaita zuwa {{provider}} idan ka dawo.",
      "stillSyncing": "Har yanzu ana daidaitawa da {{provider}}…",
      "failed_one": "Canji {{count}} bai kai {{provider}} ba.",
      "failed_other": "Canje-canje {{count}} ba su kai {{provider}} ba.",
      "retry": "Sake gwadawa",
      "needsReconnect": "{{provider}} yana buƙatar ka sake haɗawa.",
      "paused": "An dakatar da daidaitawa · Rhemn Pro ya ƙare.",
      "upgrade": "Haɓaka",
      "notSynced": "Ba a daidaita ba",
      "notSynced_aria": "Ba a daidaita zuwa {{provider}} ba. Sake gwadawa.",
      "remindersOff": "Rhemn ba ya iya isa ga Tunatarwa. Kunna ta a Saituna.",
      "dueToday": "Yau",
      "dueTomorrow": "Gobe",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Duk yini",
      "more": "+{{count}}",
      "more_aria": "Nuna ƙarin abubuwa {{count}} na duk yini",
      "less_aria": "Nuna ƙananan abubuwa na duk yini",
      "events_aria": "Abubuwa",
      "event_aria": "{{start}} zuwa {{end}}, {{title}}",
      "allDayEvent_aria": "Duk yini, {{title}}",
      "untitled": "Da aiki",
      "now": "Yanzu · har {{end}}",
      "until": "har {{end}}",
      "into": "· har cikin {{prayer}}",
      "loadError": "An kasa loda kalandarka.",
      "needsReconnect": "Google Calendar yana buƙatar ka sake haɗawa.",
      "scope": "Rhemn ba ya iya ganin Google Calendar ɗinka. Sake haɗawa ka zaɓi Calendar don ba da izini.",
      "appleOff": "Rhemn ba ya iya ganin kalandarka. Sake kunna shi a Saituna."
    },
    "plan": {
      "mostlyMeetings": "Galibi tarurruka · {{duration}} a sarari",
      "noFreeTime": "Babu lokacin hutu",
      "aroundMeetings_one": "An tsara a kewayen taro {{count}}.",
      "aroundMeetings_other": "An tsara a kewayen tarurruka {{count}}.",
      "settledBusy": "Komai ya riga ya dace a kewayen tarurrukanka."
    },
    "meeting": {
      "group_aria": "Taro yana farawa",
      "now": "yanzu",
      "takeNotes": "Ɗauki bayanai",
      "takeNotes_aria": "Ɗauki bayanai don {{title}}",
      "dismiss_aria": "Rufe",
      "announce": "{{title}} zai fara {{when}}.",
      "announceNow": "{{title}} yana farawa yanzu.",
      "yourMeeting": "Taronka"
    },
    "apple": {
      "primer": {
        "title": "Nuna kalandarka kusa da sallolinka",
        "body": "Rhemn yana karanta abubuwa da tunatarwa a wannan {{device}} don sanya su cikin ranarka. Suna zama a na'urarka. Tsara ranata yana amfani da lokutan da kake da aiki kawai.",
        "cta": "Ci gaba",
        "skip": "Ba yanzu ba",
        "footnote": "{{device}} zai tambaya sau biyu, sau ɗaya don Kalanda sau ɗaya don Tunatarwa. Za ka iya canja kowanne a Saituna."
      }
    }
  }
}
